import React from "react";
import { ChildFormProps } from "../../../types/Form-types";
import ErrorMessage from "../common-components/ErrorMessage";
import RadioCheckboxInput from "../common-components/RadioCheckboxInput";

const sourceOptions = [
  { key: "Employee Reference", label: "A. Employee Reference" },
  { key: "Placement Consultant", label: "B. Placement Consultant" },
  { key: "Direct", label: "C. Direct" },
  { key: "Job Portal", label: "D. Job Portal" },
];

interface SourcePOsitionProps extends ChildFormProps {
  handleFieldChange: (name: string, value: string) => void;
}

const Source_PositionDetails = ({
  formData,
  errors,
  handleFieldChange,
}: SourcePOsitionProps) => {
  return (
    <div>
      <div className="mb-4">
        <p className="form-section-title mb-1">Source of Recruitment:</p>
        {errors?.source && <ErrorMessage message={errors?.source} />}
        <div className="mt-2 d-flex flex-wrap gap-4 gap-md-5">
          {sourceOptions?.map((opt) => (
            <RadioCheckboxInput
              key={opt.key}
              id={opt.key}
              name={"source"}
              value={opt.key}
              label={opt.label}
              checked={formData?.source === opt.key}
              onChange={(e) => {
                handleFieldChange(e.target.name, e.target.value);
              }}
            />
          ))}
        </div>
      </div>

      {/* ── Position Applied For */}
      <div className="mb-4 pb-2 d-flex align-items-baseline gap-2">
        <label className="inline-field-label">Position Applied For:</label>
        <div className="d-flex flex-column gap-2">
          <input
            type="text"
            className="inline-field-input"
            name="position"
            value={formData?.position}
            onChange={(e) => handleFieldChange("position", e.target.value)}
          />
          {errors?.position && <ErrorMessage message={errors?.position} />}
        </div>
      </div>
      <hr className="text-secondary pb-4 mt-3" />
    </div>
  );
};

export default Source_PositionDetails;
